// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { CmmV1InboundStatusUpdateSuccessResponse } from './cmmV1InboundStatusUpdateSuccessResponse.js';
import type { IEntlibFailureResponse } from './iEntlibFailureResponse.js';
import type { TrialcardCovermymedsV1ModelsResponseModel } from './trialcardCovermymedsV1ModelsResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class CmmV1InboundStatusUpdateResponse {
    'success': boolean;
    'messages': Array<string>;

    static discriminator = "success" as const;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof CmmV1InboundStatusUpdateResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return CmmV1InboundStatusUpdateResponse.attributeTypeMap;
    }
}
